import { Helmet } from 'react-helmet-async';
import { motion } from 'framer-motion';
import { BASE_URL, OG_IMAGE } from '../utils/seo';
import { enterUp } from '../utils/animations';
import { WhyMatters } from '../components/oversight/WhyMatters';
import { AuditItems } from '../components/oversight/AuditItems';
import { MonthlyReceive } from '../components/oversight/MonthlyReceive';
import { OversightProcess } from '../components/oversight/OversightProcess';
import { OptionalMonitoring } from '../components/oversight/OptionalMonitoring';
import { ComparisonTable } from '../components/oversight/ComparisonTable';
import { PageCTA } from '../components/PageCTA';

export default function Oversight() {
    return (
        <div data-testid="oversight-page">
            <Helmet>
                <title>Monthly Oversight - White Glove Hiring</title>
                <meta name="description" content="Every month we audit your VA's time logs and give you a plain-English summary. This is the layer that makes remote leverage actually work." />
                <meta property="og:title" content="Monthly Oversight - White Glove Hiring" />
                <meta property="og:description" content="You'll never wonder what your VA is doing all day. Monthly timeclock audits, plain-English summaries, and proactive coaching." />
                <meta property="og:type" content="website" />
                <meta property="og:url" content={`${BASE_URL}/oversight`} />
                <meta property="og:image" content={OG_IMAGE} />
                <link rel="canonical" href={`${BASE_URL}/oversight`} />
            </Helmet>

            <section className="bg-navy-900 hero-pattern pt-36 pb-20">
                <div className="max-w-7xl mx-auto px-6 lg:px-12">
                    <motion.div {...enterUp}>
                        <p className="text-gold-400 text-xs font-bold tracking-[0.3em] uppercase font-inter mb-4">Monthly Oversight</p>
                        <h1 className="font-montserrat font-black text-4xl md:text-5xl lg:text-6xl text-white tracking-tight leading-tight max-w-4xl">
                            You'll Never Wonder What Your VA Is Doing All Day.
                        </h1>
                        <p className="text-gray-300 text-lg mt-5 max-w-2xl leading-relaxed">
                            Most remote hires operate in a black box. Ours don't. Every month, we audit your VA's time logs and give you a plain-English summary of what's working, what's drifting, and what needs to change. This is the layer that makes remote leverage actually work.
                        </p>
                    </motion.div>
                </div>
            </section>

            <WhyMatters />
            <AuditItems />
            <MonthlyReceive />
            <OversightProcess />
            <OptionalMonitoring />
            <ComparisonTable />

            <PageCTA
                headline="Want to See a Real Audit?"
                sub="We walk through the oversight process live on your diagnostic call. See exactly what you'd get every month."
                testId="oversight-cta"
            />
        </div>
    );
}
